<template>
    <div class="container">
        <audio style="width: 70%;" ref="audioPlayer" controls :src="AudioSrc" @ended="overAudio" @pause="onPause"
            @play="onPlay" @loadeddata="loadeddata" @timeupdate="timeupdate"></audio>
    </div>
</template>

<script>
export default {
    name: 'BaseAudio',
    props: ['AudioSrc'],
    data() {
        return {
            playstatus: false,
            isDraging: false,
            marks: {
                0: "0",
                100: "100",
            },
            currentRate: 0,
            msg: "待播放",
            // 歌曲名称


        };
    },
    methods: {
        // 监听audio标签的音频加载完成事件
        loadeddata() {
            // 需等音频加载完成，才能获取到音频的时长
            this.marks["100"] = this.s_to_MS(this.$refs.audioPlayer.duration);
        },

        // 监听audio标签的播放事件
        onPlay() {
            this.msg = "播放中";
            this.playstatus = true;
        },
        // 监听audio标签的暂停事件
        onPause() {
            this.msg = "已暂停";
            this.playstatus = false;
        },
        // 监听audio标签的停止播放事件
        overAudio() {
            this.msg = "播放结束";
            this.playstatus = false;
        },
        // 监听audio标签的播放进度改变事件
        timeupdate(e) {
            // 使用this.isDraging来控制，当拖拽进度条的过程中，停止对进度的更新——用于解决bug:拖动进度条自动回弹
            if (!this.isDraging) {
                this.currentRate = Math.floor(
                    (e.target.currentTime / this.$refs.audioPlayer.duration) * 100
                );

                this.marks["0"] = this.s_to_MS(e.target.currentTime);
            }
        },

        // 秒数转换分+秒
        s_to_MS(s) {
            let m;
            m = Math.floor(s / 60);
            s = Math.floor(s % 60);
            m += "";
            s += "";
            s = s.length == 1 ? "0" + s : s;
            if (isNaN(m)) {
                return "&infin;";
            }
            return m + ":" + s;
        },

        // 获取播放状态
        getPlayStatus() {
            this.$notify.info({
                title: "当前播放状态",
                message: this.$refs.audioPlayer.paused ? "已暂停" : "播放中",
            });
        },

        // 获取播放进度
        getCurrentTime() {
            // 已播放时长（单位秒s）
            let totalSeconds = this.$refs.audioPlayer.currentTime;
            // 分钟数
            let minites = Math.floor(totalSeconds / 60);
            // 秒数
            let seconds = Math.floor(totalSeconds % 60);

            this.$notify.info({
                title: "当前进度",
                message: `${minites}分${seconds}秒`,
            });
        },

        // 获取音频时长
        getLength() {
            // 时长（单位秒s）
            let totalSeconds = this.$refs.audioPlayer.duration;
            // 分钟数
            let minites = Math.floor(totalSeconds / 60);
            // 秒数
            let seconds = Math.floor(totalSeconds % 60);

            this.$notify.info({
                title: "时长",
                message: `${minites}分${seconds}秒`,
            });
        },
        close() {
            if (this.$refs.audioPlayer) {
                this.$refs.audioPlayer.parentNode.removeChild(this.$refs.audioPlayer);
            }
            //this.$refs.audioPlayer.stop();
           // console.log('close')
        }
    },
    beforeDestroy() {
      
    },

}
</script>

<style scoped>
.btnBox {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    align-content: space-around;
}

.container {
    text-align: center;
    /*  max-width:500px;*/
    margin: auto;
}

.listBox {
    text-align: left;
}

.subTitle {
    margin-left: 40px;
}

.musicItem {
    line-height: 40px;
    cursor: pointer;
}

.myPlayer {
    border: 4px solid #409eff;
    border-radius: 10px;
    padding: 10px 20px;
    margin: 10px;
}

.controlBox {
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    color: #409eff;
}

/* 去除手机网页点击事件的阴影 */
* {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
}
</style>
